Ext.define('SA.ScatterPlotController', {
    extend: 'SA.ViewController',

    pointCountLimit: 140000,

    constructor() {
        this.callParent(arguments);

        this.bindEvents();
    },

    bindEvents() {
        this.mon(this.model, {
            buffer: 1,
            scope: this,

            'change:attribute': this.onModelChange,
            'change:location': this.onModelChange,
            'change:filter': this.onModelChange,
            'change:filterVisibility': this.onModelChange,
            'change:geographicUnit': this.onModelChange,
            'change:lineOfBestFitEnabled': this.onModelChange,
            'change:name': this.onModelChange, 
            'change:pointColor': this.onModelChange,
            'change:pointRadius': this.onModelChange,
            'change:title': this.onModelTitleChange
        });

        this.mon(SA.AppController, 'switch:projectView', () => setTimeout(() => this.refresh(), 1));
        this.mon(this.model.getProject(), 'change:attribute', this.refresh, this);
    },

    createDefaultView() {
        this.toolbar = new SA.view.ScatterPlotToolbar({model: this.model});

        this.toolbar.on('click:viewActions:edit', this.onToolbarViewActionsEditClick, this);
        this.toolbar.on('click:viewActions:createDataTable', this.onToolbarViewActionsCreateDataTableClick, this);
        this.toolbar.on('click:viewActions:delete', this.onToolbarViewActionsDeleteClick, this);
        this.toolbar.on('activate:exportBtn', this.onActivateExportBtn, this);

        return SA.ProjectView.createHidden({
            xtype: 'scatter-plot-view',
            projectView: this.model,

            listeners: {
                scope: this,

                'change:lineOfBestFitEnabled': this.onLegendLineOfBestFitEnabledChange,
                'change:pointColor': this.onLegendPointColorChange,
                'change:pointRadius': this.onLegendPointRadiusChange,
                'change:title': this.onTitleChange,
                'change:xAttribute': this.onLegendXAttributeChange,
                'change:yAttribute': this.onLegendYAttributeChange
            }
        });
    },

    createEditView() {
        this.editController = new SA.ScatterPlotEditController(this.getEditControllerParams());

        return SA.ProjectView.createHidden(this.editController.getView());
    },

    enforcePointCountLimit() {
        var controllers = SA.data.ScatterPlotView.getControllers().sort((a, b) => b.getPointCount() - a.getPointCount()),
            totalPointCount = controllers.reduce((total, controller) => total + controller.getPointCount(), 0);

        while (totalPointCount > this.pointCountLimit) {
            let controller = controllers.shift();

            if (!controller.isActive()) {
                totalPointCount -= controller.getPointCount();

                controller.projectViews.destroyViewMode();
            }
        }
    },

    getPointCount() {
        return this.projectViews.hasViewMode() ? this.projectViews.getViewModeItem().getPointCount() : 0;
    },

    onActivateExportBtn(toolbarButton) {
        var config = new SA.ChartExportConfig({model: this.model, svgPromise: this.projectViews.getViewModeItem().getSvg()});

        Ext.widget({xtype: 'arrow-export-menu', config, toolbarButton});
    },

    onActive() {
        SA.SidebarState.create()
            .enableTabs(['locations', 'data'])
            .selectTab(SA.Sidebar.lastClickedLocationsTab() ? 'locations' : 'data')
            .setModel(this.model)
            .apply();
    },

    onLegendLineOfBestFitEnabledChange(enabled) {
        this.model.setLineOfBestFitEnabled(enabled);
    },

    onLegendPointColorChange(color) {
        this.model.setPointColor(color);
    },

    onLegendPointRadiusChange(radius) {
        this.model.setPointRadius(radius);
    },

    onLegendXAttributeChange(attribute) {
        this.model.setXAttribute(attribute);

        SA.data.RecentAttributes.add(attribute);
    },

    onLegendYAttributeChange(attribute) {
        this.model.setYAttribute(attribute);

        SA.data.RecentAttributes.add(attribute);
    },

    onModelChange() {
        this.model.save();

        this.refresh();
    },

    onModelTitleChange() {
        this.model.save();

        this.projectViews.getViewModeItem().refreshTitle();
    },

    onTitleChange(title) {
        this.model.setTitle(title);
    },

    onToolbarViewActionsCreateDataTableClick() {
        var locations = this.model.getLocations(),
            geographicUnit = this.model.getGeographicUnit(),
            attributes = this.model.getAttributes(),
            censusRelease = this.model.getCensusRelease(),
            ranking = this.model.getProject().addViewWithParams({type: 'ranking', params: {locations, geographicUnit, attributes, censusRelease}});

        SA.AppController.showProjectView(ranking);
    },

    onToolbarViewActionsDeleteClick() {
        SA.AppController.deleteView(this.model);
    },

    onToolbarViewActionsEditClick() {
        SA.AppController.showProjectView(this.model, 'edit');
    },

    refresh() {
        if (!this.isActive() || this.isEditMode()) {
            return;
        }

        this.enforcePointCountLimit();

        if (this.toolbar) {
            this.toolbar.setFilteringButtonIndicatorVisible(this.model.isFiltered());
        }

        this.projectViews.getViewModeItem().refresh();
    }
});